module.exports = __webpack_public_path__ + "img/sashimi_tempura.01834de2.jpg";